import { connect } from 'react-redux';
import UserAvatarImage from '../../components/user-avatar-image';
import { getCurrentUser } from '../../selectors/current-user-selectors';

const mapStateToProps = state => ({
  user: getCurrentUser(state),
});

export default connect(mapStateToProps)(UserAvatarImage);



// WEBPACK FOOTER //
// ./app/containers/current-user-avatar-image/current-user-avatar-image.js